// Prefer env in builds; fall back to current dev API
const BASE_URL = process.env.REACT_APP_API_URL || "https://dev.api.prontopsy.com/api/v1";
export const STRIPE_API_KEY =
  process.env.REACT_APP_STRIPE_API_KEY ||
  "pk_test_51GxqGLGRfcBcvK9WTraDAbrRRTA7POPrTYc3fIq1L6CncO7ei5aGBbHudCeKje13HTTyHwGa78X1OZUOWfdkIcCx001yuEfXA1";
export default BASE_URL;
